/**
 * Resultados mock do pipeline (lab / demo offline) — Alice LAB0020.
 * 001: primeira reunião (com apresentação dos participantes) | retorno: 002.
 */

// Espelha fixtures/meetings/001-atendimento-alice-leite/transcript.gold.txt
export const ALICE_TRANSCRIPT = `Elisa Professora Infantil 1 (professora): Boa tarde a todos. Eu sou a Elisa, professora do Infantil 1, e vou conduzir este atendimento. Para a ata inteligente ficar clara, vou apresentar quem está conosco. Comigo está a Ana, da coordenação infantil. Da família, o Emanuel Mendes Leite, pai da Alice, e a Roberta Martins Leite, mãe da Alice. E a própria Alice Rodrigues Leite, nossa aluna, está presente. Obrigada por virem. Eu pedi este atendimento porque queria conversar com vocês sobre como a Alice está se desenvolvendo na turma. Ana, pode cumprimentar?

Ana Coordenadora Infantil (coordenação): Boa tarde a todos. Obrigada, Elisa, por organizar. Estou aqui para apoiar a família e alinhar com a escola o que for combinado.

Roberta Martins Leite (mãe): Boa tarde, Elisa. Boa tarde, Ana. A gente ficou feliz com o convite. Em casa a Alice fala bastante da escola, mas também temos dúvidas sobre a linguagem e a participação dela nas rodas.

Emanuel Mendes Leite (pai): Isso. Queria ouvir de vocês, de forma objetiva, o que estão observando na sala, não só o que a Alice conta em casa.

Elisa Professora Infantil 1 (professora): Claro. A Alice é uma menina querida, se relaciona bem com os colegas e gosta das brincadeiras. O ponto de atenção que eu quis trazer é a linguagem oral e a participação nas propostas de contação de histórias. Em alguns momentos ela entende a história, mas na hora de contar ou responder ela trava e fala muito baixo. Não é uma questão de comportamento; é acompanhamento pedagógico de linguagem.

Ana Coordenadora Infantil (coordenação): Concordo com o olhar da Elisa. Do lado da coordenação, não há ocorrência disciplinar. O foco é fortalecer a comunicação da Alice e a parceria com a família, com combinados claros e prazo de retorno.

Roberta Martins Leite (mãe): Isso faz sentido. Em casa ela também fala baixo quando tem gente diferente. Alice, você gosta da hora da história na escola?

Alice Rodrigues Leite (aluna): Eu gosto. Só que às vezes eu fico com vergonha de falar na frente de todo mundo.

Emanuel Mendes Leite (pai): Obrigado por falar, filha. Elisa, o que a gente pode fazer em casa e o que a escola vai fazer daqui para frente?

Elisa Professora Infantil 1 (professora): Vamos combinar ações bem práticas. Eu, como professora, vou registrar as situações de fala da Alice durante a semana e preparar duas propostas mais curtas de contação, para ela se sentir segura. Também vou conversar com a Ana até sexta-feira para alinhar se há vaga em um momento de reforço lúdico de linguagem na próxima semana.

Ana Coordenadora Infantil (coordenação): Perfeito. Do lado da coordenação, eu confirmo até sexta esse reforço e, se necessário, oriento a família sobre materiais simples de leitura em casa. Depois retorno para vocês na próxima semana, preferencialmente na terça ou na quarta, com o feedback da Elisa e a confirmação do horário.

Elisa Professora Infantil 1 (professora): Em casa, peço que a Alice ouça ou leiam juntos uma história curta de quinze minutos, de segunda a quinta, e que ela tente contar com as próprias palavras um pedacinho para o papai ou para a mamãe. Sem pressão; o importante é ela praticar a fala com segurança.

Emanuel Mendes Leite (pai): Combinado. Eu posso fazer isso à noite. Vocês vão indicar algum livro ou história específica?

Elisa Professora Infantil 1 (professora): Sim. Até sexta eu indico duas histórias curtas adequadas à faixa etária e mando pelo canal oficial da escola, junto com a Ana.

Roberta Martins Leite (mãe): Nós topamos. Só preciso confirmar o horário do reforço porque na quarta a Alice tem outra atividade. Quando vocês retornam para a gente?

Ana Coordenadora Infantil (coordenação): Retorno na próxima semana, terça ou quarta, com o horário do reforço, as indicações de história e o que a Elisa observou na sala. Se surgir qualquer dificuldade antes, me avisem ou falem com a Elisa.

Alice Rodrigues Leite (aluna): Tá bom. Eu vou tentar contar a historinha em casa.

Emanuel Mendes Leite (pai): Só para ficar registrado o combinado: a Elisa acompanha a Alice na semana e indica as histórias até sexta; a Ana confirma o reforço e retorna para a família na próxima semana; e em casa a gente faz a história diária. É isso?

Elisa Professora Infantil 1 (professora): Exatamente isso. Eu solicitei esta conversa e vou registrar em ata esses encaminhamentos. Alice, conta com a gente. Emanuel e Roberta, obrigada pela parceria. Ana, obrigada pelo apoio. Se não houver mais nenhuma dúvida, encerramos por aqui. Boa tarde a todos.
`;

export const ALICE_ACTIONS = [
  {
    id: "act_alice_1",
    description:
      "Registrar situações de fala da Alice durante a semana e preparar propostas curtas de contação — revisar na próxima reunião",
    assignee: "Elisa Professora Infantil 1",
    dueHint: "próxima reunião",
    priority: "high",
    needsFamilyReturn: false,
    reviewAtNextMeeting: true,
    audience: "school"
  },
  {
    id: "act_alice_2",
    description:
      "Indicar duas histórias curtas adequadas à faixa etária e enviar pelo canal oficial",
    assignee: "Elisa Professora Infantil 1",
    dueHint: "próxima reunião",
    priority: "medium",
    needsFamilyReturn: false,
    reviewAtNextMeeting: true,
    audience: "school"
  },
  {
    id: "act_alice_3",
    description:
      "Confirmar reforço lúdico de linguagem e orientar materiais simples de leitura em casa",
    assignee: "Ana Coordenadora Infantil",
    dueHint: "próxima reunião",
    priority: "high",
    needsFamilyReturn: false,
    reviewAtNextMeeting: true,
    audience: "school"
  },
  {
    id: "act_alice_4",
    description:
      "Em casa: história curta de 15 minutos e Alice contar um pedaço com as próprias palavras",
    assignee: "Família",
    dueHint: "próxima reunião",
    priority: "medium",
    needsFamilyReturn: false,
    reviewAtNextMeeting: true,
    audience: "family"
  },
  {
    id: "act_alice_5",
    description:
      "Retornar à família com feedback da professora, horário do reforço e indicações de história",
    assignee: "Ana Coordenadora Infantil",
    dueHint: "próxima reunião",
    priority: "high",
    needsFamilyReturn: true,
    reviewAtNextMeeting: true,
    audience: "school"
  }
];

/** Transcrição da reunião de retorno (fixture 003). */
export const ALICE_RETORNO_TRANSCRIPT = `Elisa Professora Infantil 1 (professora): Boa tarde de novo, Emanuel, Roberta e Alice. Esta é a conversa de retorno que a Ana tinha combinado. Vamos ler o que ficou combinado e ver o que já avançou.

Ana Coordenadora Infantil (coordenação): Isso. Eu trouxe o checklist da última ata. Quero que a família e a Elisa confirmem o que foi feito, e eu digo o que ainda está pela metade do meu lado.

Elisa Professora Infantil 1 (professora): Do meu lado, concluí o registro das situações de fala da Alice na semana e usei duas propostas mais curtas de contação. Ela ainda fala baixo, mas entrou mais vezes nas rodas. Também enviei pelo canal oficial as duas histórias curtas que combinei — isso está feito.

Roberta Martins Leite (mãe): Em casa também concluímos a parte da família. De segunda a quinta a gente leu a historinha. Alice contou um pedacinho para o Emanuel na quarta. Não foi perfeito, mas ela tentou.

Alice Rodrigues Leite (aluna): Eu contei do gatinho. Fiquei com um pouquinho de vergonha, mas contei.

Emanuel Mendes Leite (pai): Foi bom ouvir. Ana, e o reforço? Na última vez a gente pediu para não ser na quarta, porque a Alice tem outra atividade.

Ana Coordenadora Infantil (coordenação): Aqui está o ponto parcial. Eu confirmei que há vaga no reforço lúdico de linguagem, então essa parte avançou. Mas ainda não fechei o horário definitivo — a grade da terça só liberou ontem — e os materiais simples de leitura ainda não foram todos enviados pelo canal. Então o encaminhamento de reforço e materiais fica parcialmente concluído.

Elisa Professora Infantil 1 (professora): Faz sentido. Então marcamos como concluídos: o meu registro e as propostas curtas, o envio das duas histórias, a prática em casa e este próprio retorno. E deixamos em andamento o pacote da Ana sobre horário e materiais.

Ana Coordenadora Infantil (coordenação): Exato. Para concluir o que ficou parcial, eu assumo duas ações novas: até sexta eu confirmo o reforço na terça, para não bater com a quarta da Alice, e aviso a família pelo canal oficial; e no mesmo prazo envio os materiais simples de leitura que faltaram.

Roberta Martins Leite (mãe): Perfeito. Se for na terça, a gente consegue. E em casa a gente continua a historinha, agora usando as que a Elisa mandou.

Elisa Professora Infantil 1 (professora): Combinado. Eu continuo o registro de fala na sala por mais uma semana e trago a evolução na próxima conversa. Alice, pode ser?

Alice Rodrigues Leite (aluna): Pode. Eu quero contar de novo.

Emanuel Mendes Leite (pai): Então, para ficar claro: o que era da semana passada, na maior parte, concluímos; o reforço ficou pela metade; e agora a Ana fecha horário e materiais, a família segue em casa, e a Elisa acompanha na sala.

Ana Coordenadora Infantil (coordenação): Isso mesmo. Eu registro esses novos encaminhamentos na ata de hoje e retorno o horário confirmado até sexta. Obrigada pela parceria.

Elisa Professora Infantil 1 (professora): Obrigada a todos. Encerramos por aqui. Boa tarde.
`;

/** Fechamento dos encaminhamentos da 002 na reunião de retorno. */
export const ALICE_PRIOR_ACTION_UPDATES = [
  {
    actionId: "act_alice_1",
    status: "done",
    note: "Registro e propostas curtas realizados; Alice entrou mais nas rodas."
  },
  {
    actionId: "act_alice_2",
    status: "done",
    note: "Duas histórias enviadas pelo canal oficial."
  },
  {
    actionId: "act_alice_3",
    status: "in_progress",
    note:
      "Vaga do reforço confirmada, mas horário definitivo e materiais ainda pendentes."
  },
  {
    actionId: "act_alice_4",
    status: "done",
    note: "Família leu de segunda a quinta; Alice contou um pedaço em casa."
  },
  {
    actionId: "act_alice_5",
    status: "done",
    note: "Retorno realizado nesta reunião."
  }
];

/** Novos encaminhamentos para concluir o que ficou parcial + continuidade. */
export const ALICE_RETORNO_ACTIONS = [
  {
    id: "act_alice2_1",
    description:
      "Confirmar reforço lúdico na terça (evitar quarta da Alice) e avisar a família pelo canal oficial",
    assignee: "Ana Coordenadora Infantil",
    dueHint: "sexta-feira",
    priority: "high",
    needsFamilyReturn: false,
    reviewAtNextMeeting: true,
    audience: "school",
    closesPriorActionId: "act_alice_3"
  },
  {
    id: "act_alice2_2",
    description:
      "Enviar pelo canal oficial os materiais simples de leitura que faltaram do encaminhamento parcial",
    assignee: "Ana Coordenadora Infantil",
    dueHint: "sexta-feira",
    priority: "high",
    needsFamilyReturn: false,
    reviewAtNextMeeting: true,
    audience: "school",
    closesPriorActionId: "act_alice_3"
  },
  {
    id: "act_alice2_3",
    description:
      "Em casa: manter história curta com as indicações da Elisa e Alice contar um pedaço",
    assignee: "Família",
    dueHint: "próxima reunião",
    priority: "medium",
    needsFamilyReturn: false,
    reviewAtNextMeeting: true,
    audience: "family"
  },
  {
    id: "act_alice2_4",
    description:
      "Continuar registro de fala da Alice na sala por mais uma semana e trazer evolução na próxima conversa",
    assignee: "Elisa Professora Infantil 1",
    dueHint: "próxima reunião",
    priority: "medium",
    needsFamilyReturn: false,
    reviewAtNextMeeting: true,
    audience: "school"
  }
];

function looksLikeAlice(body = {}) {
  const students = body.students || [];
  const first = students[0] || {};
  const ra = String(first.ra || "");
  const name = String(first.name || "");
  return ra === "LAB0020" || /alice/i.test(name);
}

function wantsAliceFollowUp(body = {}) {
  if (!looksLikeAlice(body)) return false;
  const prior = body.priorMeetingContext || {};
  const hasPrior =
    (prior.priorAtaIds && prior.priorAtaIds.length > 0) ||
    (prior.openActions && prior.openActions.length > 0);
  const blob = [
    body.title,
    body.notes,
    body.agenda,
    body.fixtureKey,
    body.audioFileName
  ]
    .filter(Boolean)
    .join(" ")
    .toLowerCase();
  if (/retorno|follow.?up|003-retorno|audio ?2|áudio ?2|segunda reun/.test(blob)) {
    return true;
  }
  return hasPrior;
}

function withStudentRa(actions, ra) {
  return (actions || []).map(a => ({
    ...a,
    studentRa: a.studentRa || ra || null
  }));
}

export function buildAliceFollowUpMockResponse(body = {}) {
  const students = body.students || [];
  const ra = students[0] && students[0].ra;
  const priorActionReviews = ALICE_PRIOR_ACTION_UPDATES.map(u => {
    const base = ALICE_ACTIONS.find(a => a.id === u.actionId) || {};
    return {
      actionId: u.actionId,
      description: base.description || u.actionId,
      assignee: base.assignee || null,
      status: u.status,
      note: u.note || null,
      audience: base.audience || "school"
    };
  });

  return {
    draftId: body.draftId || null,
    meetingId: `mock-meeting-retorno-${Date.now()}`,
    transcriptText: ALICE_RETORNO_TRANSCRIPT,
    summary:
      "Retorno da família: maioria dos encaminhamentos anteriores concluída; reforço/materiais parcial. Novas ações da Ana fecham horário na terça e envio dos materiais; família e professora seguem o acompanhamento.",
    actions: withStudentRa(ALICE_RETORNO_ACTIONS, ra),
    priorActionUpdates: ALICE_PRIOR_ACTION_UPDATES,
    priorActionReviews,
    tags: [
      "pedagogico",
      "familia",
      "atendimento_aos_responsaveis",
      "acompanhamento_individual",
      "retorno",
      "coordenacao",
      "professor"
    ],
    provider: "mock",
    fixtureKey: "003-retorno-alice-leite",
    // agent2 fica pendente até o operador validar participantes no Diário
    agents: ["stt_mock", "diarize_mock", "agent1_organize_minutes"],
    processPhase: "voice_ready",
    status: "voice_ready"
  };
}

export function buildMockProcessResponse(body = {}) {
  if (wantsAliceFollowUp(body)) {
    return buildAliceFollowUpMockResponse(body);
  }

  const students = body.students || [];
  const ra = students[0] && students[0].ra;
  return {
    draftId: body.draftId || null,
    meetingId: `mock-meeting-${Date.now()}`,
    transcriptText: ALICE_TRANSCRIPT,
    summary:
      "Tratar como acompanhamento pedagógico de linguagem oral, sem ocorrência disciplinar. Combinar reforço lúdico e leitura/contação em casa com retorno à família.",
    actions: withStudentRa(ALICE_ACTIONS, ra),
    tags: [
      "pedagogico",
      "familia",
      "atendimento_aos_responsaveis",
      "acompanhamento_individual",
      "coordenacao",
      "professor"
    ],
    provider: "mock",
    fixtureKey: "001-atendimento-alice-leite",
    // agent2 fica pendente até o operador validar participantes no Diário
    agents: ["stt_mock", "diarize_mock", "agent1_organize_minutes"],
    processPhase: "voice_ready",
    status: "voice_ready"
  };
}

/**
 * Garante priorActionUpdates/reviews no retorno, remapeando para os IDs
 * reais dos encaminhamentos abertos da reunião anterior (localStorage).
 * Cobre mock e pipeline OpenAI que ainda não devolve esse bloco.
 * Parcial (in_progress) é obrigatório quando o template/API indicar.
 */
export function ensureFollowUpPriorActions(response, draft) {
  const res = response || {};
  const prior = (draft && draft.priorMeetingContext) || {};
  const openActions = Array.isArray(prior.openActions) ? prior.openActions : [];
  if (!openActions.length) return res;

  const probe = {
    ...res,
    title: (draft && draft.title) || res.title,
    notes: (draft && draft.notes) || res.notes,
    students: (draft && draft.students) || res.students,
    priorMeetingContext: prior,
    fixtureKey: res.fixtureKey,
    audioFileName: (draft && draft.audioFileName) || res.audioFileName
  };

  const hasUpdates =
    Array.isArray(res.priorActionUpdates) && res.priorActionUpdates.length > 0;
  const isAliceReturn = wantsAliceFollowUp(probe);
  const blob = [probe.title, probe.notes, probe.fixtureKey, probe.audioFileName]
    .filter(Boolean)
    .join(" ")
    .toLowerCase();
  const looksLikeReturn = /retorno|follow.?up|segunda reun|acompanhamento do retorno/.test(
    blob
  );

  // Sem sinal de retorno e sem updates da API: não inventa fechamento
  if (!isAliceReturn && !looksLikeReturn && !hasUpdates) {
    return res;
  }

  let templates = [];
  if (hasUpdates) {
    templates = res.priorActionUpdates;
  } else if (isAliceReturn) {
    templates = ALICE_PRIOR_ACTION_UPDATES;
  }

  const pickTemplate = (openAction, index) => {
    if (!templates.length && !isAliceReturn) return null;
    const desc = String((openAction && openAction.description) || "").toLowerCase();
    const byId = templates.find(
      t => String(t.actionId || t.id) === String(openAction && openAction.id)
    );
    if (byId) return byId;
    if (isAliceReturn) {
      const aliceBase = ALICE_ACTIONS.find(a => {
        const ad = String(a.description || "").toLowerCase();
        return (
          (desc &&
            ad &&
            (desc.includes(ad.slice(0, 24)) || ad.includes(desc.slice(0, 24)))) ||
          (desc.includes("reforço") && a.id === "act_alice_3") ||
          (desc.includes("história") &&
            desc.includes("casa") &&
            a.id === "act_alice_4") ||
          (desc.includes("registrar") && a.id === "act_alice_1") ||
          (desc.includes("indicar") && a.id === "act_alice_2") ||
          (desc.includes("retornar") && a.id === "act_alice_5") ||
          (desc.includes("propostas") && a.id === "act_alice_1") ||
          (desc.includes("materiais") &&
            desc.includes("leitura") &&
            a.id === "act_alice_3")
        );
      });
      if (aliceBase) {
        return (
          templates.find(t => String(t.actionId || t.id) === aliceBase.id) ||
          ALICE_PRIOR_ACTION_UPDATES.find(t => t.actionId === aliceBase.id)
        );
      }
    }
    return (
      templates[index] ||
      (isAliceReturn ? ALICE_PRIOR_ACTION_UPDATES[index] : null)
    );
  };

  const closesDone = new Set();
  (res.actions || (draft && draft.actions) || []).forEach(a => {
    if (a && a.closesPriorActionId) {
      closesDone.add(String(a.closesPriorActionId));
    }
  });

  const priorActionUpdates = openActions
    .map((a, index) => {
      const t = pickTemplate(a, index);
      if (t) {
        return {
          actionId: a.id,
          status: t.status || "done",
          note: t.note || null,
          description: a.description || null
        };
      }
      if (closesDone.has(String(a.id))) {
        return {
          actionId: a.id,
          status: "done",
          note: null,
          description: a.description || null
        };
      }
      return null;
    })
    .filter(Boolean);

  if (!priorActionUpdates.length) return res;

  // Garante parcial Alice (in_progress) mesmo se o match por descrição falhou
  if (isAliceReturn) {
    const have = new Set(priorActionUpdates.map(u => String(u.actionId)));
    ALICE_PRIOR_ACTION_UPDATES.forEach((t, index) => {
      if (t.status !== "in_progress") return;
      const open =
        openActions.find(a => String(a.id) === String(t.actionId)) ||
        openActions.find(a =>
          /reforço|materiais|leitura/i.test(String(a.description || ""))
        ) ||
        openActions[index];
      if (!open || have.has(String(open.id))) return;
      priorActionUpdates.push({
        actionId: open.id,
        status: "in_progress",
        note: t.note || null,
        description: open.description || null
      });
    });
  }

  const priorActionReviews = priorActionUpdates.map(u => {
    const base =
      openActions.find(a => String(a.id) === String(u.actionId)) || {};
    return {
      actionId: u.actionId,
      description: base.description || u.description || u.actionId,
      assignee: base.assignee || null,
      status: u.status,
      note: u.note || null,
      audience: base.audience || "school",
      ataId: base.ataId || null,
      ataTitle: base.ataTitle || null
    };
  });

  return {
    ...res,
    priorActionUpdates,
    priorActionReviews
  };
}
